module.exports = __webpack_public_path__ + "static/hotblack-tech-illustration-7121770d080a3990456f510537ec8136.svg";